export default __webpack_public_path__ + "static/media/paris.43475adf.jpg";